import { Props_Quote } from "./Quote.props"

export const Quote = (props: Props_Quote) => {
    const { quote, author, heading } = props

    return (
        <section className="attrax-quote-snippet">
            <div className="attrax-quote-snippet__container">
                {heading.text?.value && (
                    <h2 className="attrax-quote-snippet__heading accessible-heading">
                        {heading.text.value}
                    </h2>
                )}
                <div className="attrax-quote-snippet__container-quote">
                    <div className="attrax-quote-snippet__mark"></div>
                    {quote?.text?.value && (
                        <blockquote className="attrax-quote-snippet__text">
                            {quote.text.value}
                        </blockquote>
                    )}
                    <div className="attrax-quote-snippet__author">
                        {author?.name?.value && (
                            <p className="attrax-quote-snippet__author-name">{author.name.value}</p>
                        )}
                        {author?.jobTitle?.value && (
                            <p className="attrax-quote-snippet__author-title">{author.jobTitle.value}</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}